export default function () {
    return {
        pendingReceiptLogs: [],
        requestDeliveryModalVisible: false,
        requestDeliveryType: null,
    };
}
